<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3o8XDa/tc-custom/9781615952496.jpg?1733033199116" alt="This image is the cover for the book Did Not Survive, Zoo Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Did Not Survive, Zoo Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Iris Oakley, pregnant and still recovering from her husband's murder, wants only to carry on as a keeper at Finley Memorial Zoo in Vancouver, Washington. But she is confronted by a terrifying situation: alone and with no elephant expertise, she must rescue her boss, Kevin Wallace, from being mauled by a zoo elephant. Though she gets him to safety, he dies of his injuries. No one understands why reliable old Damrey attacked the foreman, and Iris inadvertently misdirects the investigation. As zoo staff descend into anxiety and animosity, the welfare of the animals is threatened, as well as the lives of keepers. Rattled coworkers nominate Iris to find out what's going on. She finds a surprising number of motives to kill the foreman, but Damrey, the elephant, doesn't have one.</p><p>Despite the distraction of trying to construct her new life as a single mother, Iris discovers that the elephant keepers are locked in a bitter feud, the new veterinarian is keeping secrets, and an old flame still hates Wallace. New-born clouded leopard cubs cheer up the troubled staff, but even that has its dark side. Adding to the chaos, animal rights activists are picketing the zoo. They want the elephants sent to a sanctuary, but is that a better option for them than the improved exhibit that is on the drawing board? Why isn't that exhibit under construction as planned? A new foreman shows up with alarming ideas, the police keep dropping by, and animals are disappearing into thin air...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Littlewood
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a253a04